
(() => {
  const STORAGE_KEY = 'trendteleshop-wishlist';
  const BUTTON_SELECTOR = '[data-wishlist-button]';

  function getWishlist() {
    try {
      const data = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(wishlist)
      );
    } catch (error) {
      console.warn('Wunschliste konnte nicht gespeichert werden.', error);
    }

    document.dispatchEvent(
      new CustomEvent('tts:wishlist:updated', {
        detail: { wishlist }
      })
    );
  }

  function isInWishlist(productId) {
    if (!productId) return false;

    return getWishlist().some(
      item => String(item.id) === String(productId)
    );
  }

  /* =====================================
     Herz-Zustand aktualisieren
     ===================================== */

  function updateButton(button) {
    const productId = button.dataset.productId;
    if (!productId) return;

    const active = isInWishlist(productId);

    button.classList.toggle('is-active', active);
    button.classList.toggle('active', active);

    button.setAttribute(
      'aria-pressed',
      String(active)
    );

    button.setAttribute(
      'aria-label',
      active
        ? 'Produkt aus der Wunschliste entfernen'
        : 'Produkt zur Wunschliste hinzufügen'
    );

    button.setAttribute(
      'title',
      active
        ? 'Aus Wunschliste entfernen'
        : 'Zur Wunschliste hinzufügen'
    );

    const hearts = button.querySelectorAll('svg');

    hearts.forEach(svg => {
      svg.style.fill = active ? '#082f5b' : 'none';
      svg.style.stroke = '#082f5b';

      svg.querySelectorAll(
        'path, polygon, polyline'
      ).forEach(shape => {
        shape.style.fill = active ? '#082f5b' : 'none';
        shape.style.stroke = '#082f5b';
      });
    });
  }

  function updateAllButtons() {
    document
      .querySelectorAll(BUTTON_SELECTOR)
      .forEach(updateButton);
  }

  /* =====================================
     Wunschlisten-Zähler
     ===================================== */

  function updateWishlistCount() {
    const count = getWishlist().length;

    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach(counter => {
        const number = counter.querySelector(
          '[data-wishlist-count-number]'
        );

        if (number) {
          number.textContent =
            count > 99 ? '99+' : String(count);
        }

        counter.hidden = count === 0;
      });
  }

  /* =====================================
     Produkt hinzufügen / entfernen
     ===================================== */

  function toggleWishlist(button) {
    const productId = button.dataset.productId;
    const productHandle = button.dataset.productHandle;

    if (!productId) {
      console.warn(
        'Wunschlisten-Button ohne data-product-id:',
        button
      );
      return;
    }

    const wishlist = getWishlist();

    const index = wishlist.findIndex(
      item => String(item.id) === String(productId)
    );

    if (index >= 0) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push({
        id: productId,
        handle: productHandle || ''
      });
    }

    saveWishlist(wishlist);
  }

  /* =====================================
     Klick-Handler
     ===================================== */

  document.addEventListener('click', event => {
    const button = event.target.closest(
      BUTTON_SELECTOR
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleWishlist(button);
  });

  /* =====================================
     Initialisierung
     ===================================== */

  function initializeWishlist() {
    updateAllButtons();
    updateWishlistCount();
  }

  document.addEventListener(
    'DOMContentLoaded',
    initializeWishlist
  );

  document.addEventListener(
    'shopify:section:load',
    initializeWishlist
  );

  document.addEventListener(
    'tts:wishlist:updated',
    initializeWishlist
  );

  window.addEventListener(
    'storage',
    event => {
      if (event.key === STORAGE_KEY) {
        initializeWishlist();
      }
    }
  );

  /* =====================================
     Nachträglich geladene Produkte
     ===================================== */

  function observeProductCards() {
    if (!document.body) return;

    const observer = new MutationObserver(mutations => {
      let needsUpdate = false;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          if (
            node.matches?.(BUTTON_SELECTOR) ||
            node.querySelector?.(BUTTON_SELECTOR) ||
            node.matches?.('[data-wishlist-count]') ||
            node.querySelector?.('[data-wishlist-count]')
          ) {
            needsUpdate = true;
            break;
          }
        }

        if (needsUpdate) break;
      }

      if (needsUpdate) {
        initializeWishlist();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      observeProductCards
    );
  } else {
    observeProductCards();
  }

  initializeWishlist();
})();
